import Routes from '../routes';
import redirectToDomain from './redirectToDomain';

export const getTargetOrigin = (
  sourceOrigin, targetOriginSuffix = 'fashionunited.com',
) => sourceOrigin
  .replace(
    /(-au(\.))?(au\.)?[^./]+\.((com\.[^.:]+)|([^.:]+))($|(?=:))/,
    `$2${targetOriginSuffix}`,
  );

const getPortServer = (request) => {
  if (request.get('x-forwarded-port')) {
    return `:${request.get('x-forwarded-port')}`;
  }

  return '';
};

const getPortBrowser = () => {
  if (window.location.port) { return `:${window.location.port}`; }
  return '';
};

const redirectRouteToDomain = (route) => ({ req, res, query }) => {
  // eslint-disable-next-line no-underscore-dangle
  const locale = req ? req.locale : window.__NEXT_DATA__.props.locale;
  const path = Routes.findAndGetUrls(route, query).urls.as;

  const hostname = req ? req.get('host') : window.location.hostname;
  const port = req ? getPortServer(req) : getPortBrowser();
  const targetOrigin = getTargetOrigin(`https://${hostname}${port}`);

  if (locale !== 'en-US' && hostname !== 'localhost') {
    redirectToDomain(path, res, targetOrigin);
  }
  return {};
};

export default redirectRouteToDomain;
